import React, { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import { Form } from 'components/forms'
import Close from '../../shared/icons/Close'
import style from '../DataTable.module.scss'
import Button from 'components/Button'
import Divider from 'components/Divider'
import { ContentBlock } from 'components/ContentBlock'

export const FilterForm = ({ filterValues, setFilter, clearFilter, toggleFilterWindow, FilterComponent, withButtons = true, width, height }) => {
	const [t, i18n] = useTranslation()

	return(
		<ContentBlock className={`${style.filterForm}`} style={{ width: width ? `${width}%` : '100%', height: height ? `${height}%` : '100%' }}>
			<div className={style['filterForm-header']}>
				<h2>{t('common.strings.list_filter')}</h2>
				<Close size={20} onClick={toggleFilterWindow}/>
			</div>
			<Form
				initialValues={filterValues}
				onSubmit={setFilter}
				render={({ formState, formApi }) => (
					<div className={style['filterForm-body']}>
						<FilterComponent
							clearFilter={clearFilter}
							toggleFilterWindow={toggleFilterWindow}
							formState={formState}
							formApi={formApi}
							t={t}
							i18n={i18n}
						/>
						{withButtons &&
							<Fragment>
								<Divider height={20}/>
								<Button fWidth type='submit' text={t('common.buttons.apply')} status='primary'/>
								<Divider height={10}/>
								<Button fWidth onClick={clearFilter} status='cancelation' text={t('common.buttons.clear_filter')}/>
							</Fragment>
						}
					</div>
				)}
			/>
		</ContentBlock>
	)
}

export const FilterButton = props => (
	<div className={`${style['filterForm-btn']} btn`} {...props}>
		Filter
		<span className={style['arrow-icon']}/>
	</div>
)
